<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Movimiento de caja</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <k-table
          :deleteButton="puede_anular"
          :createButton="puede_registrar"
          
          :editButton="false"
          ref="gastos"
          @crear="crear"
          :path="path"
          @eliminar="eliminar"
          :columns="[
            {
              display: 'Fecha',
              value: 'fecha',
            },
            {
              display: 'Persona',
              value: 'persona.nombre',
            },
            {
              display: 'Vendedor',
              value: 'vendedor.descripcion',
            },
            {
              display: 'Valor',
              value: 'valor',
              numeric: true,
            },
            {
              display: 'Sucursal',
              value: 'bodega.descripcion',
            },
            {
              display: 'Oficinista',
              value: 'oficinista.nombre',
            },
            {
              display: 'Detalle',
              value: 'detalle',
            },
            {
              display: 'Tipo de movimiento',
              value: 'tipo_gasto.descripcion',
            },
            {
              display: 'Creación',
              value: 'created_at',
            },
          ]"
        ></k-table>
      </div>
    </div>
    <modal
      name="gastoOficina"
      scrollable
      resizable
      reset
      adaptive
      height="auto"
      width="60%"
    >
      <gasto-oficina
        :bodegas="bodegas"
        :tiposGastos="tiposGastos"
        :puedeRegistrarFecha="puede_registrar_fecha"
        @cancelar="cancelar"
        @saved="savedGastoOficina"
        :puedeConsultar="puede_consultar"
        ref="gastoOficina"
        v-model="selectedGastoOficina"
      ></gasto-oficina>
    </modal>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import GastoOficina from "./GastoOficina.vue";
export default {
  components: {
    GastoOficina,
  },
  data: function () {
    return {
      path: url + "/gastos-oficina",
      selectedGastoOficina: null,
      bodegas: [],
      tiposGastos: [],
      puede_anular: false,
      puede_registrar: false,
      puede_registrar_fecha: false,
      puede_consultar: false,
    };
  },
  methods: {
    cargarDatos: function () {
      axios
        .get(url + "/gastos-oficina/datos")
        .then(({ data }) => {
          this.bodegas = data.bodegas;
          this.tiposGastos = data.tiposGastos;
          this.puede_anular = data.puede_anular;
          this.puede_registrar = data.puede_registrar;
          this.puede_registrar_fecha = data.puede_registrar_fecha;
          
        })
        .catch(() => {
          swal("Hubo un error al cargar los datos.", "Error", "error");
        });
    },
    cancelar: function () {
      this.$modal.hide("gastoOficina");
    },
    savedGastoOficina: function () {
      this.$modal.hide("gastoOficina");
      this.$refs.gastos.loadRows();
    },
    crear: function () {
      this.selectedGastoOficina = {
        valor: "",
        detalle: "",
        bodega_id: "",
        tipo_gasto_codigo: "",
        fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        persona_id: '',
        vendedor_id: ''
      };
      this.$modal.show("gastoOficina");
    },
    eliminar: function (gastoOficina) {
      swal({
        title: "¿Deseas anular el gasto de oficina seleccionado?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/gastos-oficina/" + gastoOficina.id, {
              _method: "DELETE",
            })
            .then(() => {
              swal(
                "El gasto ha sido anulado exitósamente.",
                "Realizado",
                "success"
              );
              this.$refs.gastos.loadRows();
            })
           .catch(({ response }) => {
              const status = response.status;
              if (status == 409) {
                this.errores = response.data.errors;
                swal("La caja ya está cerrada.", "Aviso", "warning");
              } 
              else if (statos == 408) {
                swal("No se puede anular un movimiento que haya sido cruzado en rol.", "Aviso", "warning");
              }
              else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
  },
  mounted: function () {
    this.cargarDatos();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/administrativo/ListaGastosOficina.vue